import { Link } from 'react-router-dom';
import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { toast, ToastContainer } from 'react-toastify';
import { useTranslation } from 'react-i18next';

export default function VerifyAccount() {
  const [email, setEmail] = useState('');
  const navigate = useNavigate();
  const { t } = useTranslation("global");

  useEffect(() => {
    localStorage.removeItem("user");
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
  
    if (!email) {
      toast.error(t("verifyAccount.errors.enterEmail"));
      return;
    }
  
    try {
      const response = await fetch(
        `${process.env.REACT_APP_API_URL}/otp`,
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ email }),
        }
      );
  
      const result = await response.json();
  
      if (result.code === 200) {
        if (result.data.isVerified) {
          toast.success(t("verifyAccount.success.alreadyVerified"), {
            autoClose: 2000,
            onClose: () => navigate("/login"),
          });
        } else {
          toast.success(t("verifyAccount.success.enterOtp"), {
            autoClose: 2000,
            onClose: () => navigate("/verify-account-otp"),
          });
          localStorage.setItem("otpAllowed", "true");
          localStorage.setItem("user", JSON.stringify(result));
        }
      } else {
        console.log(result.message);
        toast.error(result.message || t("verifyAccount.errors.general"));
      }
    } catch (error) {
      toast.error(t("verifyAccount.errors.alreadyActivated"));
    }
  };
  

  return (
    <section style={{ backgroundColor: "#193C6E", minHeight: "100vh" }}>
      <ToastContainer />
      <div className="container h-100">
        <div className="row d-flex justify-content-center align-items-center min-vh-100">
          <div className="col-lg-6 col-md-12">
            <img src="assets/imgs/layer 2.png" width="100%" alt={t("verifyAccount.imgAlt")} />
          </div>
          <div className="col-lg-6 col-md-12">
            <div className="card-singin p-4 shadow rounded-4">
              <div >
                <img src="assets/imgs/تميز copy 1.svg" alt="Taamayaz Logo" className="mb-3" />
                <h2 className="second-color ">{t("verifyAccount.title")}</h2>
                <p className="paragraph-color ">
                  {t("verifyAccount.subtitle")}
                </p>
              </div>

              <form onSubmit={handleSubmit}>
                <div className="row">
                  <div className="col-md-12 col-lg-12">
                    <label htmlFor="email" className=" d-block mb-2">
                      {t("verifyAccount.emailLabel")}
                    </label>
                    <input
                      type="email"
                      id="email"
                      className="form-control mb-2"
                      placeholder={t("verifyAccount.emailPlaceholder")}
                      value={email}
                      onChange={(e) => setEmail(e.target.value)}
                    />
                  </div>
                </div>

                <button
                  type="submit"
                  style={{ backgroundColor: "#352E64", color: "#fff" }}
                  className="btn w-100 py-2 my-3"
                >
                  {t("verifyAccount.continueBtn")}
                </button>
              </form>

              <p style={{ color: "#352E64" }} className=" mt-3">
                {t("verifyAccount.haveAccount")}{" "}
                <Link to="/login" className="fw-bold">
                  {t("verifyAccount.signIn")}
                </Link>
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
